// extracted by mini-css-extract-plugin
export default {"colorGrey1":"#fff","colorGrey3":"#f5f5f5","colorBlue9":"#003a8c","colorBlue5":"#40a9ff","draggableBodyRow":"draggableBodyRow_draggableBodyRow__gPw-P"};